var React = require('react');

function Headspace (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.9824 9.9117C18.1541 12.3727 17.0307 13.7612 16.3447 14.7395C15.2839 15.8674 13.9426 17.4056 10.5421 17.4924C7.65637 17.6107 6.22923 16.3247 5.03593 15.2046C3.48369 13.4775 3.07816 12.4521 3.00008 9.9117C2.99231 8.34999 3.58508 6.79572 4.62998 5.42339C6.0886 3.34111 8.40489 2.64688 10.5421 2.50465C12.7881 2.41782 14.5742 3.5615 15.7908 4.79242C17.3508 6.45667 17.8262 7.88483 17.9824 9.91211","fill":"#FF7300"}));
}

Headspace.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","className":"headspace","fill":"none"};

module.exports = Headspace;

Headspace.default = Headspace;
